import type * as types from './types';

import admin from './admin.permissions';
import manager from './manager.permissions';
import viewer from './viewer.permissions';

const PERMISSIONS_MATRIX: types.MATRIX = { admin, viewer, manager };

export default PERMISSIONS_MATRIX;
